var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-gis-wms-map-swipe"},[_c('div',{staticClass:"content-gis-map",staticStyle:{"position":"relative"}},[_c('div',{style:(_vm.minHeight),attrs:{"id":`${_vm.nameMap}_${_vm.initialDate}`}}),_vm._v(" "),(_vm.isLoadingLayer)?_c('div',{staticClass:"gis-layer-loading-overlay"},[_c('div',{staticClass:"preloader"})]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }